__turbopack_context__.v({
  "buttonContainer": "VideoEmbed-module-scss-module__3f2rgG__buttonContainer",
  "customImageAndPlayButton": "VideoEmbed-module-scss-module__3f2rgG__customImageAndPlayButton",
  "image": "VideoEmbed-module-scss-module__3f2rgG__image",
  "playButton": "VideoEmbed-module-scss-module__3f2rgG__playButton",
  "root": "VideoEmbed-module-scss-module__3f2rgG__root",
  "setButtonCentered": "VideoEmbed-module-scss-module__3f2rgG__setButtonCentered",
  "video": "VideoEmbed-module-scss-module__3f2rgG__video",
  "videoDescription": "VideoEmbed-module-scss-module__3f2rgG__videoDescription",
});
